import { DatePicker, Space } from 'antd';
import { Tab } from '@headlessui/react';
import { classNames } from '@wajeez-web/core/utils';
import React, { useState } from 'react';
import moment from 'moment';
import CalendarLocale from 'rc-picker/lib/locale/en_US';
import { RangeValue } from 'rc-picker/lib/interface';
import AutoSelectDatesPanel from '../General/AutoSelectDatesPanel';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;

interface DateRangePickerInputProps {
  datesProp: Date[];
  setDates: (dates: Date[]) => void;
}

const tabs = ['Preset', 'Custom Dates'];
const DateRangePickerInput: React.FC<DateRangePickerInputProps> = ({
  datesProp,
  setDates,
}) => {
  const [inputDates, setInputDates] = useState<Date[]>(datesProp);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleDates = (datesInput: any) => {
    console.log(
      777,
      datesInput,
      datesInput?.map((date: any) => date.$d)
    );
    return datesInput?.map((date: any) => date.$d);
  };

  return (
    <Space
      className=" border p-2 rounded-md"
      direction="vertical"
      dir="rtl"
      size={12}
    >
      <RangePicker
        locale={{
          lang: {
            placeholder: 'اختيار التاريخ',
            rangePlaceholder: ['البداية', 'النهاية'],
            ...CalendarLocale,
          },
          timePickerLocale: {
            placeholder: 'اختيار الوقت',
          },
          dateFormat: 'DD-MM-YYYY',
          monthFormat: 'MM-YYYY',
          dateTimeFormat: 'DD-MM-YYYY HH:mm:ss',
          weekFormat: 'wo-YYYY',
        }}
        defaultValue={[dayjs(datesProp[0]), dayjs(datesProp[1])]}
        value={[dayjs(datesProp[0]), dayjs(datesProp[1])]}
        onChange={(datesInput) => setDates(handleDates(datesInput))}
        bordered={false}
        panelRender={(panelNode) => (
          <>
            <div className="md:flex justify-center items-start hidden ">
              {panelNode}
              <AutoSelectDatesPanel
                oldestDate={new Date(Date.UTC(2011, 0, 1))}
                setInputDates={setDates}
                setIsOpen={setIsOpen}
              />
            </div>
            <div className=" md:hidden w-full  ">
              <Tab.Group>
                <Tab.List
                  className={'flex space-s-1 rounded-xl bg-primary/20 p-1'}
                >
                  {tabs.map((item) => (
                    <Tab
                      key={item}
                      className={({ selected }) =>
                        classNames(
                          'w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-primary',
                          'ring-white ring-opacity-60 ring-offset-2 ring-offset-primary focus:outline-none focus:ring-2',
                          selected
                            ? 'bg-white shadow'
                            : 'text-gray-400 hover:bg-white/[0.12] '
                        )
                      }
                    >
                      {' '}
                      {item}
                    </Tab>
                  ))}
                </Tab.List>
                <Tab.Panels>
                  <Tab.Panel>
                    <AutoSelectDatesPanel
                      oldestDate={new Date(Date.UTC(2019, 0, 1))}
                      setInputDates={setDates}
                      setIsOpen={setIsOpen}
                    />
                  </Tab.Panel>
                  <Tab.Panel>{panelNode}</Tab.Panel>
                </Tab.Panels>
              </Tab.Group>
            </div>
          </>
        )}
        open={isOpen}
        className={'input'}
        onFocus={() => setIsOpen(true)}
        onOpenChange={(open) => setIsOpen(open)}
      />
    </Space>
  );
};

export default DateRangePickerInput;
